/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useContext, useEffect, useState } from 'react';

import { Hidden } from '@coursera/cds-core';

import { getMetaHeight, isMetaNavEnabled } from 'bundles/ent-website/components/MetaNavigation';
import useScrollInfo from 'bundles/page-header/components/hooks/useScrollInfo';
import IsMobileScreenContext from 'bundles/page/contexts/IsMobileScreenContext';
import MobileCategoryNavigation from 'bundles/unified-seo-content-common/components/hub-page/MobileCategoryNavigation';
import Navigation from 'bundles/unified-seo-content-common/components/hub-page/Navigation';
import { NAVIGATION_OFFSET } from 'bundles/unified-seo-content-common/constants';
import type { NavigationLinkWithSubItems } from 'bundles/unified-seo-content-common/types';

type InputProps = {
  activeCategorySlug: string;
  navigationLinks: NavigationLinkWithSubItems[];
};

export type Props = InputProps;

export const CategoryNavigation = ({ activeCategorySlug, navigationLinks }: Props) => {
  const isMetaNav = isMetaNavEnabled();
  const [isMetaNavVisible, setMetaNavVisible] = useState<boolean>(isMetaNav);
  const { isScrollingDown } = useScrollInfo({ delta: 50 });
  const { isMobileScreen } = useContext(IsMobileScreenContext);

  useEffect(() => {
    if (isMetaNav) {
      setMetaNavVisible(!isScrollingDown);
    }
  }, [isMetaNav, isScrollingDown]);

  const styles = {
    navigationBarContainer: css`
      width: 100%;
      padding: 10px 15px;
      position: sticky;
      top: ${NAVIGATION_OFFSET};
      border-bottom: ${isMobileScreen ? '1px solid var(--cds-color-neutral-stroke-primary-weak)' : ''};
      background-color: var(--cds-color-neutral-background-primary);
      z-index: 10;
    `,
    navigationBarContainerMetaNav: css`
      top: calc(${NAVIGATION_OFFSET} + ${getMetaHeight()});
    `,
  };

  return (
    <div
      css={[styles.navigationBarContainer, isMetaNavVisible ? styles.navigationBarContainerMetaNav : null]}
      className="rc-CategoryNavigation"
    >
      <Hidden mdUp>
        <MobileCategoryNavigation activeCategorySlug={activeCategorySlug} navigationLinks={navigationLinks} />
      </Hidden>
      <Hidden smDown>
        <Navigation activeCategorySlug={activeCategorySlug} navigationLinks={navigationLinks} />
      </Hidden>
    </div>
  );
};

export default CategoryNavigation;
